import React from 'react';
import { IconProps } from '../types/types';

const TSLA: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path fill="#E82127" d="M0 0h18v18H0z"/><path d="M9 15l1.5-8c1.334 0 1.654.272 1.715.872 0 0 .894-.335 1.346-1.016C11.8 6.037 10 6 10 6L9 7.25 8 6s-1.8.037-3.56.856c.45.68 1.345 1.016 1.345 1.016.061-.6.39-.871 1.715-.872L9 15z" fill="#fff"/><path d="M9 5.608a11.35 11.35 0 014.688.955C13.91 6.16 14 6 14 6c-1.823-.724-3.53-.994-5-1-1.47.006-3.177.276-5 1 0 0 .114.2.313.563A11.349 11.349 0 019 5.607z" fill="#fff"/></svg>
);

export default TSLA;